import { BankAccountType } from '../enums/bank-account-type.enum';
import { StripeBankAccountStatus } from '../enums/stripe-bank-account-status.enum';

export interface BankAccount {
  id: string;
  bankName: string;
  routingNumberMasked: string; // masked, never full number
  accountNumberMasked: string; // masked, never full number
  accountType: BankAccountType;
  isPrimary: boolean; // is the current Stripe payout destination
  isExternallyManaged: boolean; // created via Stripe webhook (read-only)
  status: StripeBankAccountStatus; // SINGLE SOURCE OF TRUTH for the account state
}

export interface CreateContractorBankAccount {
  bankName: string; // required, maxLength: 100
  routingNumber: string; // required, maxLength: 9, regex: ^\d{9}$
  accountNumber: string; // required, maxLength: 20
  accountType: BankAccountType; // required, default: "checking"
}

export interface UpdateContractorBankAccount {
  bankName?: string; // optional, maxLength: 100
  routingNumber?: string; // optional, maxLength: 9, regex: ^\d{9}$
  accountNumber?: string; // optional, maxLength: 20
  accountType?: BankAccountType; // optional
}
